import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Box from "@mui/joy/Box";
import { Configuration } from "./config";
import { routes } from "./routes";
import { useLoadingState } from "../hooks/useLoading";
import { Loader as LoaderComponent } from "../components/loader";
import { ErrorStatusNotification } from "../components/errorStatus";

const AcceptRequest = lazy(() => import("./acceptRequest"));
const ChargerDetails = lazy(() => import("./chargerDetails"));
const ChargerList = lazy(() => import("./chargerList"));
const Home = lazy(() => import("./home"));
const Onboarding = lazy(() => import("./onboarding"));
const OnboardProvider = lazy(() => import("./onboardProvider"));
const Profile = lazy(() => import("./profile"));
const ReceiverSignup = lazy(() => import("./receiverSignup"));
const RequestDetails = lazy(() => import("./requestDetails"));
const RequestList = lazy(() => import("./requestList"));
const VehicleList = lazy(() => import("./vehicleList"));
const VehicleDetails = lazy(() => import("./vehicleDetails"));

export function Pages() {
  const { Loader } = useLoadingState();

  return (
    <>
      <Suspense fallback={<LoaderComponent />}>
        <Box style={routeContainerStyle}>
          <Routes>
            <Route path={`${routes.acceptRequest.route}/:id`} element={<AcceptRequest/>} />
            <Route path={routes.addVehicle.route} element={<ReceiverSignup title="Add a vehicle" vehicleOnly={true} />} />
            <Route path={`${routes.chargerDetails.route}/:id`} element={<ChargerDetails/>} />
            <Route path={routes.chargerList.route} element={<ChargerList/>} />
            <Route path={routes.config.route} element={<Configuration/>} />
            <Route path={routes.home.route} element={<Home/>} />
            <Route path={routes.onboarding.route} element={<Onboarding/>} />
            <Route path={routes.onboardProvider.route} element={<OnboardProvider/>} />
            <Route path={routes.receiverSignup.route} element={<ReceiverSignup getLocation={true} />} />
            <Route path={routes.requestCharge.route} element={<ReceiverSignup getLocation={true} skipCreate={true} />} />
            <Route path={`${routes.requestDetails.route}/:id`} element={<RequestDetails/>} />
            <Route path={routes.requestList.route} element={<RequestList/>} />
            <Route path={routes.providerServiceList.route} element={
              <RequestList
                activeRequestTitle="Active Service"
                isProvider={true}
                pastRequestsTitle="Past Services"
                title="Charge Provider Services"
              />
            } />
            <Route path={routes.profile.route} element={<Profile/>} />
            <Route path={`${routes.vehicleDetails.route}/:id`} element={<VehicleDetails/>} />
            <Route path={routes.vehicleList.route} element={<VehicleList/>} />
          </Routes>
        </Box>
      </Suspense>

      <ErrorStatusNotification />
      {Loader}
    </>
  )
}

export const routeContainerStyle = {
  margin: "4rem 1rem 1rem 1rem",
};
